import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';

import { FuseSidebarModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { DialogLocationsGroupsModule } from './dialogs/dialog-locations-groups.module';
import { LocationsGroupsFiltersModule } from './filters/filters.module';
import { LocationsGroupsComponent } from './locations-groups.component';
import { MutationCreateLocationGroupGQL, MutationUpdateLocationGroupGQL } from './services/api/mutations.service';
import { QueryLocationGroupGQL, QueryLocationsGroupsPaginatedGQL } from './services/api/queries.service';
import { LocationsGroupsService } from './services/locations-groups-resolver.service';

const routes: Routes = [
  {
    path: 'localizacoes/grupos',
    pathMatch: 'full',
    component: LocationsGroupsComponent,
    canActivate: [AuthenticatedGuard],
    data: { title: 'CORE.SERVICES.NAVIGATION.LOCATIONS.GROUPS' }
  }
];

@NgModule({
  declarations: [
    LocationsGroupsComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),

    MatIconModule,
    MatTooltipModule,
    MatMenuModule,
    MatButtonModule,
    MatRippleModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    TranslateModule,

    FuseSharedModule,
    FuseSidebarModule,
    DialogLocationsGroupsModule,
    LocationsGroupsFiltersModule
  ],
  providers: [
    QueryLocationsGroupsPaginatedGQL,
    QueryLocationGroupGQL,
    MutationCreateLocationGroupGQL,
    MutationUpdateLocationGroupGQL,
    LocationsGroupsService
  ]
})
export class LocationsGroupsModule { }
